/**
 * Replaces any empty `<span class="survey-node-container"></span>` elements used as survey placeholders
 * (i.e., `<span class="survey-node-container"></span>`) with the
 * template placeholder string `{{survey.link}}`.
 *
 * @param {string} htmlString - The HTML content containing survey span nodes.
 * @returns {string} - Updated HTML with `{{survey.link}}` replacing survey spans.
 */
const replaceSurveySpanWithPlaceholder = (htmlString) => {
  return (
    htmlString?.replace(
      /<span[^>]*class=["']survey-node-container["'][^>]*><\/span>/gi,
      '{{survey.link}}'
    ) || ''
  );
};

export { replaceSurveySpanWithPlaceholder };
